import { gql } from '@apollo/client';

export const PARTIAL_BAU_ACCOUNT_DETAILS = gql`
  query partialBauAccountDetails($input: PartialBauAccountDetailsInput!) {
    partialBauAccountDetails(input: $input) {
      roles {
        code
      }
      partialEmail
      partialPhones
      stageName
      accountStatusCode
    }
  }
`;
